
import Footer from "../components/footer/Footer"
import Header from "../components/header/Header"
import About from "../components/sections/about/About"
import Banner from "../components/sections/banner/Banner"
import Choose from "../components/sections/choose/Choose"
import Client from "../components/sections/client/Client"
import Contact from "../components/sections/contact/Contact"
import Service from "../components/sections/services/Service"

const Index = () => {
    return (
        <>
            <Header />
            <Banner />
            <About />
            <Service />
            <Choose />
            <Client />
            <Contact />
            <Footer />
        </>
    )
}

export default Index